import { Dispatch } from "react";
import jwtAxios from "../../utils/jwtAxios";
import { AppActions } from "../../types/AppActions";
import { Beacon, UserProfile } from "../../types/models/Beacon";
import { GET_LATEST_OR_NEARBY_BEACONS, GET_BEACONS_COUNT, GET_BUSINESS_BEACONS_IN_GROUP, GET_BUSINESS_BEACONS_IN_GROUP_BY_DATE, SET_BEACON_SEARCH_TEXT, SET_CATEGORY_FILTER_VALUE, GET_USER_DETAILS } from "../../types/actions/Beacon.actions";
import { fetchError, showMessage } from "./Common";
import { UploadImagePostRequest } from "../../types/models/UploadImagePostRequest";
import { UploadImagePostResponse } from "../../types/models/UploadImagePostResponse";
import { MakeBeacon } from "../../types/models/MakeBeacon";
import { UpdateBeacon } from "../../types/models/UpdateBeacon";
import { AxiosResponseWithDetail } from "../../types";
import { PricingTier } from "../../features/subscriptions/SubscriptionTable";

export const getMapkitToken = (
  callback?: (success: boolean, token?: string) => void
) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get("/api/business/mapkittoken").then((response) => {
      if (response.status === 200) {
        if (response.data.token) {
          // dispatch({ });
          callback && callback(true, response.data.token);
        } else {
          callback && callback(false);
        }
      } else {
        callback && callback(false);
      }
    });
  };
};

export const getUserSubscription = (callback: (success: boolean, userSubscription?: string, pricingTiers?: PricingTier[]) => void) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get("/api/subscription/current")
      .then((response) => {
        if (response.status === 200) {
          const { current_tier, pricing_tiers } = response.data;
          const tiers = ["tier_starter", "tier_pro", "tier_enterprise"];
          const special_case_tier = "prod_RQ2MocUAHgYMR5";
          if (tiers.some(tier => current_tier == tier)) {
            callback(true, current_tier, pricing_tiers);
          } else {
            const tier = pricing_tiers.find((tier: { name: string, price: number, id: string }) => tier.id === current_tier);

            if (tier) {
              const tierNameParted = tier.name.split(' ');
              const tierName = `tier_${tierNameParted[1].toLowerCase()}`;
              callback(true, tierName, pricing_tiers);
              // Special case 
            } else if (current_tier == special_case_tier) {
              const tierName = "tier_unlimited";
              callback(true, tierName, pricing_tiers);
            } else {
              console.error(`Error finding subscription tier: ${response.status}`);
              callback(false, undefined, pricing_tiers);
            }
          }
        } else {
          console.error(`Error fetching current subscription with status: ${response.status}`);
          callback(false);
        }
      })
      .catch((error) => {
        console.error('Error fetching current subscription:', error);
        callback(false);
      });
  };
};


export const getNearbyBeacons = (lat: number, lng: number, rad: number, callBack: (result: boolean) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/admin/adminnearbybeacons', { params: { latitude: lat, longitude: lng, radius: rad } })
      .then((data) => {
        if (data.status === 200) {
          const beacons: Beacon[] = data.data.beacons;
          dispatch({ type: GET_LATEST_OR_NEARBY_BEACONS, payload: beacons });
          dispatch({ type: GET_BEACONS_COUNT, payload: data.data.totalBeacons });
          callBack(true);
        } else {
          dispatch(fetchError("Request failed. Status:" + data.status));
          callBack(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callBack(false);
      });
  };
};

export const getLatestBeacons = (page: number, callBack: (result: boolean) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/admin/adminlatestbeacons', { params: { page: page } })
      .then((data) => {
        if (data.status === 200) {
          const beacons: Beacon[] = data.data.beacons;
          dispatch({ type: GET_LATEST_OR_NEARBY_BEACONS, payload: beacons });
          dispatch({ type: GET_BEACONS_COUNT, payload: data.data.totalBeacons });
          callBack(true);
        } else {
          dispatch(fetchError("Request failed. Status:" + data.status));
          callBack(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callBack(false);
      });
  };
};

export const getBusinessBeaconsInGroup = (groupId: string | null, isArchived: boolean | null, page: number, callBack: (result: boolean) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/business/businessbeaconsingroup', { params: { group_id: groupId, is_archived: isArchived, page: page } })
      .then((data) => {
        if (data.status === 200) {
          const beacons: Beacon[] = data.data.beacons;
          dispatch({ type: GET_BUSINESS_BEACONS_IN_GROUP, payload: beacons });
          dispatch({ type: GET_BEACONS_COUNT, payload: data.data.totalBeacons });
          callBack(true);
        } else {
          dispatch(fetchError("Request failed. Status:" + data.status));
          callBack(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callBack(false);
      });
  };
};

export const getBusinessBeaconsInGroupByDate = (groupId: string | null, startDate: string, endDate: string, callBack: (result: boolean) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/business/businessbeaconsingroupbydate', { params: { group_id: groupId, startDate: startDate, endDate: endDate } })
      .then((data) => {
        if (data.status === 200) {
          const beacons: Beacon[] = data.data.beacons;
          dispatch({ type: GET_BUSINESS_BEACONS_IN_GROUP_BY_DATE, payload: beacons });
          callBack(true);
        } else {
          dispatch(fetchError("Request failed. Status:" + data.status));
          callBack(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callBack(false);
      });
  };
};

export const getBusinessBeaconsInGroupTextSearch = (groupId: string | null, queryText: string, page: number, callBack: (result: boolean) => void) => {

  const textQuery = queryText + ":*";

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/business/businessbeaconsingrouptextsearch', { params: { group_id: groupId, page: page, queryText: textQuery } })
      .then((data) => {
        if (data.status === 200) {
          const beacons: Beacon[] = data.data.beacons;
          dispatch({ type: GET_BUSINESS_BEACONS_IN_GROUP, payload: beacons });
          dispatch({ type: GET_BEACONS_COUNT, payload: data.data.totalBeacons });
          callBack(true);
        } else {
          dispatch(fetchError("Request failed. Status:" + data.status));
          callBack(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callBack(false);
      });
  };
};

export const getBusinessBeaconsInGroupByCategory = (groupId: string | null, category: string, page: number, callBack: (result: boolean) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/business/businessbeaconsingroupbycategory', { params: { group_id: groupId, page: page, category: category } })
      .then((data) => {
        if (data.status === 200) {
          const beacons: Beacon[] = data.data.beacons;
          dispatch({ type: GET_BUSINESS_BEACONS_IN_GROUP, payload: beacons });
          dispatch({ type: GET_BEACONS_COUNT, payload: data.data.totalBeacons });
          callBack(true);
        } else {
          dispatch(fetchError("Request failed. Status:" + data.status));
          callBack(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callBack(false);
      });
  };
};

export const uploadBeaconImage = (groupId: string, file: File, fileSize: number, width: number, height: number ,callBack: (imageId?: string) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    // Get upload URL
    const request: UploadImagePostRequest = { groupid: groupId, filesize: fileSize, width: width, height: height };
    jwtAxios.post('/api/beacon/uploadbeaconimage2', request)
      .then((data: AxiosResponseWithDetail) => {
        if (data.status === 200) {
          const response: UploadImagePostResponse = data.data;
          var signedUrl = response.url;
          if (signedUrl && signedUrl !== null && signedUrl.length > 0) {
            const reader = new FileReader();
            reader.onload = (event) => {
              const fileBytes = event?.target?.result;
              if (fileBytes) {
                fetch(signedUrl, {
                  method: "PUT",
                  body: fileBytes
                }).then((result) => {
                  if (result.status === 200) {
                    console.log("Succeeded to upload a file to s3");
                    callBack(response.id);
                  }
                  else {
                    dispatch(fetchError("Failed to upload image to s3. Status:" + data.status));
                  }
                })
                  .catch((err) => {
                    /*
                      This block usually gets hit if you have an adblocker turned on, or S3
                      is having downtime. which causes the fetch.then(...) to not fire.
                    */
                    dispatch(fetchError(err.message));
                    callBack(undefined);
                  });
              }
              else {
                dispatch(fetchError("Could not read image file in memory. The file is empty."));
              }
            };
            reader.onerror = () => {
              dispatch(fetchError("Could not read image file in memory"));
            };
            reader.readAsArrayBuffer(file);
          }
        } else {
          dispatch(fetchError(
            data.detail
              ? data.detail
              : "Request failed. Status:" + data.status
          ));
          callBack(undefined);
        }
      })
      .catch((error) => {
        dispatch(fetchError(
          error.response.data.detail
            ? error.response.data.detail
            : error.message
        ));
        callBack(undefined);
      });
  };
};

export const uploadBeaconFace = (beacon_id: string, formData: FormData, beacon_group_id: string | undefined, callback: (result: boolean) => void) => {
  return (dispatch: Dispatch<AppActions>) => {

    const config = {
      headers: {
          "Content-Type": "multipart/form-data"
      }
    };
    
    const url = "/api/beacon/beaconfaceimage?&beacon_id=" + beacon_id + "&beacongroup_id=" + beacon_group_id;

    jwtAxios
      .post(url, formData, config)
      .then((data) => {
        if (data.status === 200) {
          callback(true);
        } else {
          dispatch(fetchError("Request failed. Status: " + data.status));
          callback(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(
          error.response.data.detail
            ? error.response.data.detail
            : error.message));
        callback(false);
      });
  };
};

export const deleteBeaconFace = (beaconId: string, beaconGroupId: string, callBack: (result: boolean) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.post('/api/beacon/deletebeaconface', {
      BeaconId: beaconId,
      BeaconGroupId: beaconGroupId
    })
      .then((data: AxiosResponseWithDetail) => {
        if (data.status === 200) {
          callBack(true);
        } else {
          callBack(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(
          error.response.data.detail
            ? error.response.data.detail
            : error.message));
        callBack(false);
      });
  };
};

export const makeBeacon = (beacon: MakeBeacon, callBack: (result: { success: boolean, beaconId?: string }) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.post('/api/business/makebusinessbeacon', beacon)
      .then((data: AxiosResponseWithDetail) => {
        if (data.status === 200) {
          callBack({success: true, beaconId: data.data?.beaconId});
        } else {
          dispatch(fetchError(
            data.detail
              ? data.detail
              : "Request failed. Status:" + data.status
          ));
          callBack({success: false});
        }
      })
      .catch((error) => {
        dispatch(fetchError(
          error.response.data.detail
            ? error.response.data.detail
            : error.message));
        callBack({success: false});
      });
  };
};

export const updateBeacon = (beacon: UpdateBeacon, callBack: (result: boolean) => void) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.post('/api/beacon/updatebeacon', beacon)
      .then((data: AxiosResponseWithDetail) => {
        if (data.status === 200) {
          callBack(true);
        } else {
          dispatch(
            fetchError(
              data.detail
                ? data.detail
                : "Request failed. Status:" + data.status
            )
          );
          callBack(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(
          error.response.data.detail
            ? error.response.data.detail
            : error.message));
        callBack(false);
      });
  };
};

export const setBeaconSearchText = (text: string | null) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({ type: SET_BEACON_SEARCH_TEXT, payload: text });
  };
};

export const setCategoryFilter = (category: string | null) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({ type: SET_CATEGORY_FILTER_VALUE, payload: category });
  };
};

export const getUserDetail = (userId: string, callback: (success: boolean, data?: any) => void) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/admin/adminuserdetails', { params: { userId: userId } })
      .then((response) => {
        if (response.status === 200) {
          // Rip out the piece of the response we want.
          const user: UserProfile = response.data;

          // Dispatch response to reducer (note that user detail currently isnt persisted).
          dispatch({ type: GET_USER_DETAILS, payload: user });

          // Send it back in the callback.
          callback(true, user);
        } else {
          dispatch(fetchError("Request failed. Status:" + response.status));
          callback(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callback(false);
      });
  };
};

export const importBeacons = (group_id: string, formData: FormData, callback: (result: boolean) => void) => {
  return (dispatch: Dispatch<AppActions>) => {

    const config = {
      headers: {
          "Content-Type": "multipart/form-data"
      }
    };

    jwtAxios
      .post("/api/business/uploadcsv?group_id=" + group_id, formData, config)
      .then((data) => {
        if (data.status === 200) {
          dispatch(showMessage("Beacons imported successfully"));
          callback(true);
        } else {
          dispatch(fetchError("Request failed. Status: " + data.status));
          callback(false);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const errorMessage = error.response.data.detail || error.response.data.errors[0];
          dispatch(fetchError("Import Error: " + errorMessage));
          callback(false);
        } else {
          // Handle any other unexpected errors
          dispatch(fetchError(error.message));
          callback(false);
        }
      });
  };
};

export const deleteBeacon = (beaconName: string, beaconId: string, callback: (result: boolean) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.post('/api/beacon/deletebeacon', { beaconid: beaconId })
      .then((data) => {
        if (data.status === 200) {
          // Deletion performed 
          dispatch(showMessage( beaconName + " has been deleted"));
          callback(true);
        } else {
          // Deletion Failed
          dispatch(fetchError("Request failed. Status:" + data.status));
          callback(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(
          error.response.data.detail
            ? error.response.data.detail
            : error.message));
        callback(false);
      });
  };
};

export const clearBeacons = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({ type: GET_BUSINESS_BEACONS_IN_GROUP, payload: [] });
  };
};
